<template>
  <BaseLayout page-default-back-link="/nativeTab/news" pageTitle="消息详情" :showFooter="true">
    <div v-if="!data">
      <ion-list>
        <ion-item>
          <ion-thumbnail slot="start">
            <ion-skeleton-text animated></ion-skeleton-text>
          </ion-thumbnail>
          <ion-label>
            <h3>
              <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
            </p>
            <p>
              <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
      <ion-list>
        <ion-item>
          <ion-thumbnail slot="start">
            <ion-skeleton-text animated></ion-skeleton-text>
          </ion-thumbnail>
          <ion-label>
            <h3>
              <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
            </p>
            <p>
              <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
      <ion-list>
        <ion-item>
          <ion-thumbnail slot="start">
            <ion-skeleton-text animated></ion-skeleton-text>
          </ion-thumbnail>
          <ion-label>
            <h3>
              <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
            </p>
            <p>
              <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
    <div v-else>
      <DetailsListItem
        v-for="(item, index) in data"
        :key="index"
        :title="item.title"
        :time="item.createTimeStr"
        :content="item.dataDetails"
        :file="item.file"
        :lawyerName="item.fromUserName"
        :processNodeTblId="item.processNodeTblId"
        :tblId="item.tblId"
        :needUpload="item.upFile == 1"
      />
    </div>

    <template v-slot:footer>
      <div class="footer-btn">
        <img class="phoneImage m-r-35" src="@/assets/phone.png" />
        <span>联系律师</span>
      </div>
    </template>
  </BaseLayout>
</template>

<script>
import { ref, onMounted } from 'vue'
import { delay, newsApi } from '@/apis'
import { useRoute } from 'vue-router'
import { DetailsListItem } from '@/view/news/components'

export default {
  setup(props, { emit }) {
    const route = useRoute()
    console.log('useRoute', route.query)
    const data = ref()
    const getData = async () => {
      const detailsData = await newsApi.details({
        ...route.query,
      })
      data.value = detailsData.map((item) => ({
        ...item,
        file: item.fileShowList ? item.fileShowList.map((f) => f.validUri) : [],
      }))
      console.log('detailsData', detailsData)
    }
    onMounted(() => {
      getData()
    })
    return { data }
  },
  components: { DetailsListItem },
}
</script>